import { createErrorMessage } from "../service";
import api from "../api";

const pricingService = {
  resource: "pricing",
  getPrices(params = {}, onSuccess = () => {}, onError = () => {}) {
    params.filters = api.helpers.formFilters(params.filters);
    params = api.helpers.clearResource(params);
    return api
      .get(`/${this.resource}/prices`, {
        params
      })
      .then(res => {
        let data = { ...res.data };
        onSuccess(data);
        return data;
      })
      .catch(res => {
        createErrorMessage(res);
        onError(res);
      });
  },
  getCosts(params = {}, onSuccess = () => {}, onError = () => {}) {
    params.filters = api.helpers.formFilters(params.filters);
    params = api.helpers.clearResource(params);
    return api
      .get(`/${this.resource}/costs`, {
        params
      })
      .then(res => {
        let data = { ...res.data };
        onSuccess(data);
        return res;
      })
      .catch(res => {
        createErrorMessage(res);
        onError(res);
      });
  }
};

export default pricingService;
